import React from 'react';

import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
interface BrainstormIconProps {
	size?: 'small' | 'medium';
}

export const BrainstormIcon = ({ size = 'medium' }: BrainstormIconProps = {}) => (
	<LightbulbIcon label="" spacing="spacious" size={size} />
);
